import { render, staticRenderFns } from "./MyClientSwitch.vue?vue&type=template&id=50a2e2e0"
import script from "./MyClientSwitch.vue?vue&type=script&lang=ts"
export * from "./MyClientSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports